<template>
	<div>
		<v-row>
			<v-col>
				<p class="text-large"><b>Thank you!</b></p>
				<p class="text-large">Please activate your account by setting a password
				Your password must be at least 6 characters and it must contain at least one number or special character.
				</p>
				<p class="text-large"><b>Don’t know what this is for?</b></p>
				<p class="text-large">You’ve been sent a link to this page because you are interested research by Meisterworks. <br/>If you think that you have received this in error, please let us know.
				</p>
			</v-col>
			<v-col >
				<v-card class="ml-auto mr-auto mt-5" max-width="460px" v-if="!success && mode == 'resetPassword'">
					<v-toolbar color="black" dark>
						<v-toolbar-title class="mw-h2">{{actionTitle}}</v-toolbar-title>
						<v-spacer />
					</v-toolbar>
					<v-card-text class="text-right">
						<v-text-field
						v-if="mode == 'resetPassword'"
						id="password"
						label="Password"
						name="password"
						v-model="password" 
						prepend-icon="fa-lock"
						type="password"
						/>
					</v-card-text>
					<div >
						<v-alert :value="error" dense text type="warning">{{errorMsg}}</v-alert>
					</div>  
					<v-card-actions>
						<v-spacer />
						<v-btn color="primary" text @click="handleResetPassword">Set</v-btn>
					</v-card-actions>
				</v-card>
				<v-card class="ml-auto mr-auto mt-5 pa-6" v-if="success">
					<p class="text-large" v-if="success">Password reset successful. <a href="/login"> Login here </a></p>
				</v-card>

			</v-col>
		</v-row>
    </div>
</template>	
<script>

	import firebase from "firebase";
	const auth = firebase.auth();
	export default{
		name: "PasswordReset",
		data: () => {
			return{
				email: null, 
				password: null,
				error: false,
				errorMsg: null,
				resp: null,
				success: false
			}
		},
		computed:{
			mode() {return this.getParameterByName("mode")},
			actionCode() { return  this.getParameterByName("oobCode")},
			continueUrl() {return this.getParameterByName("continueUrl")},
			lang() {return this.getParameterByName("lang")},
			actionTitle(){
				var mode = this.mode;
				if( mode == "resetPassword"){
					return "Set Password"
				}
				return " "
			}
		},
		methods: {
			getParameterByName(name){
				return this.$route.query[name];
			},
			handleResetPassword() {
				const self = this;
				if( !self.actionCode ){
					self.error = true;
					self.errorMsg = "Incorrectly formatted link - please contact Meisterworks."
					return;
				}
				// Localize the UI to the selected language as determined by the lang
				// parameter.
				// Verify the password reset code is valid.
				firebase.auth().verifyPasswordResetCode(self.actionCode).then(function(email) {
					if( !email ){ return; }
					var newPassword = self.password;
					// TODO: Show the reset screen with the users email and ask the user for
						// the new password.

					// Save the new password.
					firebase.auth().confirmPasswordReset(self.actionCode, newPassword).then(function(resp) {
						self.resp = resp;
						self.success = true;
						// Password reset has been confirmed and new password updated.

						// TODO: Display a link back to the app, or sign-in the user directly
						// if the page belongs to the same domain as the app:
						// auth.signInWithEmailAndPassword(accountEmail, newPassword);

						// TODO: If a continue URL is available, display a button which on
						// click redirects the user back to the app via continueUrl with
						// additional state determined from that URL's parameters.
					}).catch(function() {
						self.error = true;
						self.errorMsg = "Password reset error - please contact Meisterworks."
					// Error occurred during confirmation. The code might have expired or the
					// password is too weak.
					});
				}).catch(function() {
					self.error = true;
					self.errorMsg = "There was a problem setting up your password. The link you used may have expired for security reasons. Please get in touch with your contact at Meisterworks to receive a fresh link."
				// Invalid or expired action code. Ask user to try to reset the password
				// again.
				});
			},
			handleRecoverEmail() {
				const self = this;
				// Localize the UI to the selected language as determined by the lang
				// parameter.
				var restoredEmail = null;
				// Confirm the action code is valid.
				auth.checkActionCode(self.actionCode).then(function(info) {
				// Get the restored email address.
				restoredEmail = info['data']['email'];

				// Revert to the old email.
				return auth.applyActionCode(self.actionCode);
				}).then(function() {
				// Account email reverted to restoredEmail

				// TODO: Display a confirmation message to the user.

				// You might also want to give the user the option to reset their password
				// in case the account was compromised:
				auth.sendPasswordResetEmail(restoredEmail).then(function() {
				// Password reset confirmation sent. Ask user to check their email.
				}).catch(function(error) {
					error;
				// Error encountered while sending password reset code.
				});
				}).catch(function(error) {
					error;
				// Invalid code.
				});
			},
			handleVerifyEmail() {
				const self = this;
				// Localize the UI to the selected language as determined by the lang
				// parameter.
				// Try to apply the email verification code.
				auth.applyActionCode(self.actionCode).then(function(resp) {
					resp;
				// Email address has been verified.

				// TODO: Display a confirmation message to the user.
				// You could also provide the user with a link back to the app.

				// TODO: If a continue URL is available, display a button which on
				// click redirects the user back to the app via continueUrl with
				// additional state determined from that URL's parameters.
				}).catch(function(error) {
					error;
				// Code is invalid or expired. Ask the user to verify their email address
				// again.
				});
			}
		},
		created(){
			var self = this;

			// Handle the user management action.
			switch ( self.mode) {
				case "resetPassword":
					// Display reset password handler and UI.
					// self.handleResetPassword();
				break;
				case "recoverEmail":
					// Display email recovery handler and UI.
					self.handleRecoverEmail();
				break;
				case "verifyEmail":
					// Display email verification handler and UI.
					self.handleVerifyEmail();
				break;
				default:
				// Error: invalid mode.
			}
		}
	}
</script>